import * as Types from '../../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
export type ConfirmIntegrationActionModalIntegrationFragment = { __typename?: 'IntegrationConfiguration', id: string, name: string, integrationType: Types.IntegrationType, associatedActionFlows: Array<{ __typename?: 'ActionFlowIntegrationSummary', id: string, name?: string | null, usedInPublishedVersion: boolean }> };

export const ConfirmIntegrationActionModalIntegrationFragmentDoc = gql`
    fragment ConfirmIntegrationActionModalIntegration on IntegrationConfiguration {
  id
  name
  integrationType
  associatedActionFlows {
    id
    name
    usedInPublishedVersion
  }
}
    `;